<cb-dialog>
    <form class="flex-col flex" #colourItemForm="ngForm">
        <cb-input
            type="text"
            name="code"
            label="Item Code"
            [required]="true"
            [readonly]="isEdit()"
            [(ngModel)]="mappedItem.code"
        >
        </cb-input>
        <cb-input
            type="text"
            name="name"
            label="Item Name"
            [required]="true"
            [(ngModel)]="mappedItem.name"
        >
        </cb-input>
        <cb-checkbox
            name="showInClientSpecification"
            label="Show on Create Schedule"
            [(ngModel)]="mappedItem.showInClientSpecification"
        >
        </cb-checkbox>
        <cb-text-area
            label="Text for Specification"
            name="textForSpecification"
            [(ngModel)]="mappedItem.textForSpecification"
            [maxlength]="1024"
        >
        </cb-text-area>
        <cb-checkbox name="isActive" label="Active" [(ngModel)]="mappedItem.isActive">
        </cb-checkbox>

        <!-- [dynamicImageLoader]="true" -->
        @if (mappedItem.imageUrl) {
            <cb-image-button [baseUrl]="mappedItem.imageUrl"> </cb-image-button>
        }
        @if (mappedItem.colourItemImageFile) {
            <cb-image-button
                [baseUrl]="mappedItem.colourItemImageFile"
                [images]="[mappedItem.colourItemImageFile]"
            >
            </cb-image-button>
        }
        <input
            hidden
            type="file"
            #fileInput
            (change)="selectFile($event.target.files[0])"
            (click)="$event.target.value = null"
            accept=".jpg,.jpeg,.png,.gif,image/jpeg,image/gif,image/png"
        />
        <div>
            <button mat-button (click)="fileInput.click()" style="display: block">
                <mat-icon> delete </mat-icon>
                @if (!mappedItem.image && !mappedItem.colourItemImageFile) {
                    <span> &nbsp;Upload Image </span>
                }
                @if (mappedItem.image || mappedItem.colourItemImageFile) {
                    <span> &nbsp;Replace Image </span>
                }
            </button>
            @if (mappedItem.image || mappedItem.colourItemImageFile) {
                <button mat-button style="display: block" (click)="removeImage()">
                    <mat-icon> delete </mat-icon>
                    &nbsp;Remove Image
                </button>
            }
        </div>
    </form>
    <div actions>
        <span class="flex"></span>
        <button
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="colourItemForm.pristine || colourItemForm.invalid"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
